<template>
  <aside
    id="slider"
    style="height:100%; max-height: 50px !important; overflow-y: auto;"
    class="main-sidebar"
  >
    <!-- sidebar: style can be found in sidebar.less -->
    <section class="sidebar">
      <!-- Sidebar user panel -->
      <router-link to="/Admin/Profile">
      <!-- <a style="cursor: pointer" @click="toProfile()"> -->
        <div class="user-panel">
          <div class="pull-left image">
            <img :src="profileImg" class="img-circle" alt="User Image" />
          </div>
          <div class="pull-left info">
            <p>{{ fullname }}</p>
              <i
                class="fa fa-circle"
                :style="`color:${currentUser.state.color}`"
              ></i>
              {{ currentUser.state.name }}
          </div>
        </div>
      <!-- </a> -->
      </router-link>
      <!-- /.search form -->
      <!-- sidebar menu: : style can be found in sidebar.less -->
      <ul data-widget="tree" class="sidebar-menu">
        <!-- <li class="header">MAIN NAVIGATION</li> -->
        
        <li
          @click="closeToggle"
          v-bind:class="[$route.name == 'DashboardAmin' ? 'active' : '']"
        >
          <router-link to="/Admin/Dashboard">
            <i class="fa fa-home"></i>
            <span>หน้าแรก</span>
            <span
              class="pull-right-container"
              style="display:none!important;"
            ></span>
          </router-link>
        </li>

        <li v-bind:class="[isActive == 'mobile' ? 'active' : '']" >
          <a href="#" @click.prevent="active('mobile')">
            <i class="fa el-icon-mobile"></i> <span> โทรศัพท์เคลื่อนที่ </span>
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"></i>
            </span>
          </a>
          <ul class="treeview-menu">
            <va-slide-item
              v-for="(item,index) in mobileMenuItems"
              :data="item"
              :key="index"
              :type="item.type"
              :isHeader="item.isHeader"
              :icon="item.icon"
              :name="item.name"
              :name_th="item.name_th"
              :badge="item.badge"
              :items="item.items"
              :router="item.router"
              :link="item.link"
            >
            </va-slide-item>
          </ul>
        </li>

        <li v-bind:class="[isActive == 'broadband' ? 'active' : '']" >
          <a href="#" @click.prevent="active('broadband')">
            <i class="fa el-icon-s-platform"></i> <span> อินเทอร์เน็ตความเร็วสูงประจำที่ </span>
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"></i>
            </span>
          </a>
          <ul class="treeview-menu">
            <va-slide-item
              v-for="(item,index) in broadbandMenuItems"
              :data="item"
              :key="index"
              :type="item.type"
              :isHeader="item.isHeader"
              :icon="item.icon"
              :name="item.name"
              :name_th="item.name_th"
              :badge="item.badge"
              :items="item.items"
              :router="item.router"
              :link="item.link"
            >
            </va-slide-item>
          </ul>
        </li>

        <li v-bind:class="[isActive == 'others' ? 'active' : '']" >
          <a href="#" @click.prevent="active('others')">
            <i class="fa el-icon-more"></i> <span> อื่นๆ </span>
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"></i>
            </span>
          </a>
          <ul class="treeview-menu">
            <va-slide-item
              v-for="(item,index) in slideMenuItems.filter(i => this.permissions[i.name[0]].includes('true'))"
              :data="item"
              :key="index"
              :type="item.type"
              :isHeader="item.isHeader"
              :icon="item.icon"
              :name="item.name"
              :name_th="item.name_th"
              :badge="item.badge"
              :items="item.items"
              :router="item.router"
              :link="item.link"
            >
            </va-slide-item>
          </ul>
        </li>


      </ul>
    </section>
    <!-- /.sidebar -->
  </aside>
</template>
<style scoped>
.fa-angle-left.fa-angle-rg {
  /* -webkit-transform: rotate(10deg)!important;
    transform: rotate(10deg)!important; */
}
.sidebar-menu>li>a>.fa {
  top: 15px;
}
</style>

<script>
import { mapState, mapActions } from "vuex";
import VASlideItem from "../template/VASlideItem";
import slideMenuItemList from "../../lib/slideMenuItems";
import mobileItemList from "../../lib/mobileSideItems";
import broadbandItemList from "../../lib/broadbandSideItems";

export default {
  data() {
    return {
      arrShow: true,
      Report_promotion_mobile_type: null,
      Services_rate: null, // permission.Services_rate[1]
      Program_technologies: null, // permission.Program_technologies[1]
      Services_change: null, // permission.Services_change
      Pro_seconds_G5: null, // permission.Pro_seconds_G5
      Promotion_table_avg: null, // permission.Promotion_table_avg
      Promotion_percent: null, // permission.Promotion_percent
      Services_trends: null, // permission.Services_trends
      Fast_internet_home_G9: null, // permission.Fast_internet_home_G9
      Services_internet: null, // permission.Services_internet
      Fast_internet_home_G11: null, // permission.Fast_internet_home_G11
      Fast_internet_home_G12: null, // permission.Fast_internet_home_G12
      Reportview_promotion: null, // permission.Reportview_promotion
      Report_blockchain: null, // permission.Report_blockchain
      Upload_save: null,
      Manage_user: null,
      Manage_admin:null,
      Manage_operator:null,
      Typegroup:null,
      ListOperator:null,
      Manage_average:null,
      Manage_service:null,
      Manage_mobile_service:null,
      Manage_terms_and_condition:null,
      Manage_privacy_data_policy:null,
      Manage_security_policy:null,
      Manage_cookie_privacy:null,
      Manage_question:null,
      Manage_article:null,
      Manage_news:null,
      Manage_mobile:null,
      Manage_internet:null,
      Manage_request_mobile:null,
      Manage_request_internet:null,
      Manage_data:null,
      Manage_mobile_service :null,
      Manage_banner: null,
      Popular_proMobile:null,
      Popular_proInternet:null,
      Access_log : null,
      Report_promotion_ranking : null,
      User_behavior: null,
      Uteleme: null,
      isActive: '',
      permissions: {}
    };
  },
  computed: {
    ...mapState({
      fullname: store => store.Menu.fullname,
      profileImg: store => store.Menu.profileImg,
      unreadMessagesCount: store => store.Menu.messages.length,
      unreadMessagesCount: store => store.Menu.messages.length,
      unreadNotificationsCount: store => store.Menu.notifications.length,
      remainTasksCount: store => store.Menu.remark.length,
      currentUser: store => store.Menu.main
    })
  },
  created() {
    const permission = JSON.parse(atob(this.$cookies.get("user_nbtc").permission));
    this.permissions = permission;
  },
  mounted() {
    this.setCookie();
    const permission = JSON.parse(atob(this.$cookies.get("user_nbtc").permission));
    this.Report_promotion_mobile_type = permission.Report_promotion_mobile_type ? permission.Report_promotion_mobile_type[1] : ''
    this.Services_rate = permission.Services_rate ? permission.Services_rate[1] : ''
    this.Program_technologies = permission.Program_technologies ? permission.Program_technologies[1] : ''
    this.Services_change = permission.Services_change ? permission.Services_change[1] : ''
    this.Pro_seconds_G5 = permission.Pro_seconds_G5 ? permission.Pro_seconds_G5[1] : ''
    this.Promotion_table_avg = permission.Promotion_table_avg ? permission.Promotion_table_avg[1] : ''
    this.Promotion_percent = permission.Promotion_percent ? permission.Promotion_percent[1] : ''
    this.Services_trends = permission.Services_trends ? permission.Services_trends[1] : ''
    this.Fast_internet_home_G9 = permission.Fast_internet_home_G9 ? permission.Fast_internet_home_G9[1] : ''
    this.Services_internet = permission.Services_internet ? permission.Services_internet[1] : ''
    this.Fast_internet_home_G11 = permission.Fast_internet_home_G11 ? permission.Fast_internet_home_G11[1] : ''
    this.Fast_internet_home_G12 = permission.Fast_internet_home_G12 ? permission.Fast_internet_home_G12[1]  : ''
    this.Reportview_promotion = permission.Reportview_promotion ? permission.Reportview_promotion[1] : ''
    this.Report_blockchain = permission.Report_blockchain ? permission.Report_blockchain[1] : ''
    this.Upload_save = permission.Upload_save ? permission.Upload_save[1] : ''
    this.Manage_user = permission.Manage_user ? permission.Manage_user.includes("true") : false
    this.Manage_admin = permission.Manage_admin ? permission.Manage_admin.includes("true") : false
    this.Manage_operator = permission.Manage_operator ? permission.Manage_operator.includes("true") : false
    this.Typegroup = permission.Typegroup ? permission.Typegroup.includes("true") : false
    this.ListOperator = permission.ListOperator ? permission.ListOperator.includes("true") : false
    this.Manage_average = permission.Manage_averagetosave ? permission.Manage_averagetosave.includes("true") : false
    this.Manage_service = permission.Manage_service ? permission.Manage_service.includes("true") : false
    this.Manage_mobile_service = permission.Manage_mobile_service ? permission.Manage_mobile_service.includes("true") : false
    this.Manage_terms_and_condition = permission.Manage_terms_and_condition ? permission.Manage_terms_and_condition.includes("true") : false
    this.Manage_privacy_data_policy = permission.Manage_privacy_data_policy ? permission.Manage_privacy_data_policy.includes("true") : false
    this.Manage_security_policy = permission.Manage_security_policy ? permission.Manage_security_policy.includes("true") : false
    this.Manage_cookie_privacy = permission.Manage_cookie_privacy ? permission.Manage_cookie_privacy.includes("true") : false
    this.Manage_question = permission.Manage_question ? permission.Manage_question.includes("true") : false
    this.Manage_article = permission.Manage_article ? permission.Manage_article.includes("true") : false
    this.Manage_news = permission.Manage_news ? permission.Manage_news.includes("true") : false
    this.Manage_banner = permission.Manage_banner ? permission.Manage_banner.includes("true") : false
    this.Manage_mobile = permission.Manage_mobile ? permission.Manage_mobile.includes("true") : false
    this.Manage_internet = permission.Manage_internet ? permission.Manage_internet.includes("true") : false
    this.Manage_request_mobile = permission.Manage_request_mobile ? permission.Manage_request_mobile.includes("true") : false
    this.Manage_request_internet = permission.Manage_request_internet ? permission.Manage_request_internet.includes("true") : false
    this.Manage_data = permission.Manage_data ? permission.Manage_data.includes("true") : false
    this.Popular_proMobile = permission.Popular_proMobile ? permission.Popular_proMobile.includes("true") : false
    this.Popular_proInternet = permission.Popular_proInternet ? permission.Popular_proInternet.includes("true") : false
    this.Access_log = permission.Access_log ?  permission.Access_log.includes("true") : false
    this.Report_promotion_ranking = permission.Report_promotion_ranking ? permission.Report_promotion_ranking.includes("true") : false
    this.User_behavior = permission.User_behavior ? permission.User_behavior.includes("true") : false
    this.Uteleme = permission.Uteleme ? permission.Uteleme.includes('true') : false
  },
  methods: {
    ...mapActions({
      setCookie: "Menu/setCookie"
    }),
    arrShoww() {
      if (this.arrShow) {
        this.arrShow = false;
      } else {
        this.arrShow = true;
      }
    },
    closeToggle() {
      this.arrShow = true;
    },
    toProfile() {
      this.$router.push({ name: "Profile" });
    },
    active(type) {
      this.isActive != type ? this.isActive = type : this.isActive = '';
    }
  },
  name: "va-slider",
  props: {
    slideMenuItems: {
      type: Object/Array,
      default() {
        // return slideMenuItemList.filter(item => permissions[item.name[0]].includes('true'))
        return slideMenuItemList
      }
    },
    mobileMenuItems: {
      type: Object/Array,
      default() {
        return mobileItemList
      }
    },
    broadbandMenuItems: {
      type: Object/Array,
      default() {
        return broadbandItemList
      }
    }
  },
  components: {
    "va-slide-item": VASlideItem
  }
};
</script>
<style>
/* .main-sidebar {
  background: #8f2d2d;
  overflow-y: scroll;
} */
.main-sidebar::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

.main-sidebar::-webkit-scrollbar {
  width: 5px;
  background-color: #f5f5f5;
}

.main-sidebar::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: rgb(139, 139, 139);
}
</style>
